import { powerupById, type PowerupClass } from '../core';
import { CAST_FADE_SEC } from './levels';

/** Shared bed under every trick. One class accent plays with it. */
export const CAST_BED = 'trick-cast-shared';

export { CAST_FADE_SEC };

const ACCENT: Record<PowerupClass, string> = {
  universal: 'accent-universal',
  stealth: 'accent-stealth',
  infiltration: 'accent-infiltration',
  guardian: 'accent-guardian',
  tidecaller: 'accent-tidecaller',
  grove: 'accent-grove',
};

/** Class accent for a catalog id. An unknown id uses the universal flourish. */
export function accentFile(powerupId: string): string {
  const power = powerupById(powerupId);
  return ACCENT[power?.classId ?? 'universal'];
}

export function castFiles(powerupId: string): readonly string[] {
  return [CAST_BED, accentFile(powerupId)];
}
